import store from '@/store/store'
import BigNumber from "bignumber.js";

export function logout() {
    store.commit('setMember', null);
    location.href = '/login'
    history.pushState(null, '/login', '/login')
}

/**
 * 乘法
 * @param {*} a 
 * @param {*} b 
 */
export function mul(a, b) {
    let x = new BigNumber(a)
    let y = x.multipliedBy(b)           // '1.8'
    return y
}

/**
 * 除法
 * @param {*} a 
 * @param {*} b 
 */
export function div(a, b) {
    let x = new BigNumber(a)
    let y = new BigNumber(b)           // '1.8'
    return x.dividedBy(y)
}

/**
 * 防抖
 * @param {*} fun 
 * @param {*} delay 
 * @returns 
 */
export function debounce(fun, delay) {
    return function (args) {
        //获取函数的作用域和变量
        let that = this
        let _args = args
        //每次事件被触发，都会清除当前的timeer，然后重写设置超时调用
        clearTimeout(fun.id)
        fun.id = setTimeout(function () {
            fun.call(that, _args)
        }, delay)
    }
}

/**
 * 截流
 * @param {*} fun 
 * @param {*} delay 
 * @returns 
 */
export function throttle(fun, delay) {
    let last, deferTimer
    return function (args) {
        let that = this;
        let _args = arguments;

        let now = +new Date();
        if (last && now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fun.apply(that, _args);
            }, delay)
        } else {
            last = now;
            fun.apply(that, _args);
        }
    }
}

export function formatNumber(number, scale = 2) {
    const newNum = new Number(number)
    if (newNum >= 1000 && newNum < 1000000) {
        return (newNum / 1000).toFixed(scale) + 'k';
    } else if (newNum >= 1000000) {
        return (newNum / 1000000).toFixed(scale) + 'M';
    } else {
        return newNum.toFixed(scale);
    }
}

export function getLatestTimestamp(interval = 1) {
    const now = new Date();
    let minutes = now.getMinutes();
    let offset = minutes % interval;
    now.setMinutes(minutes - offset);
    now.setSeconds(0);
    now.setMilliseconds(0);
    return now.getTime();
}

export function getYesterdayTimestamp() {
    let today = new Date();
    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    return yesterday.getTime();
}

/**
 * 动态修改icon
 */
// export function changeIcon(iconUrl = "/favicon.ico") {
//     const changeFavicon = link => {
//         let $favicon = document.querySelector('link[rel="icon"]');
//         if ($favicon !== null) {
//             $favicon.href = link;
//         } else {
//             $favicon = document.createElement("link");
//             $favicon.rel = "icon";
//             $favicon.href = link;
//             document.head.appendChild($favicon);
//         }
//     };
//     // 设置图标地址
//     let iconUrl = `./favicon.ico`
//     // 动态修改网站图标
//     changeFavicon(iconUrl);
// }



// WEBPACK FOOTER //
// ./src/utils/index.js